import { render, staticRenderFns } from "./CK_subpagehero.vue?vue&type=template&id=264cf813&"
import script from "./CK_subpagehero.vue?vue&type=script&lang=js&"
export * from "./CK_subpagehero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports